export const SPREADSHEET_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const saveDownloadedFile = (body: Blob, headers: Headers, type: string, fallbackFileName?: string) => {
  const contentDisposition = headers.get('content-disposition') ?? '';
  const fileName = /filename="([^"]*)"/i.exec(contentDisposition)?.[1] ?? fallbackFileName;

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(new Blob([body], { type }));
  link.setAttribute('download', fileName ?? 'download');

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
